import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
	name: 'inputCurrency',
	pure: false
})
export class InputCurrencyPipe extends CurrencyPipe implements PipeTransform {
	transform(value: any, ...args: any[]): any {
		if (value !== null && value !== "") {
			const number = isNaN(value) ? parseInt(value.replace(/[^0-9\.]/g, ''), 0) : value;
			if (isNaN(number))
				return super.transform(0, 'USD', 'symbol', '1.000');
			else
				return super.transform(number, 'USD', 'symbol', '1.000');
		}
		return super.transform(0, 'USD', 'symbol', '1.000');
	} 
}
